import Chip from '@mui/material/Chip';

export const nonScheduleSessionVerificationTableHeader = () => [
  {
    headerName: 'Student / Batch',
    field: 'student_name',
    toolTipGetter: true,
    width: 250,
  },
  {
    headerName: 'Course',
    field: 'individual_course_name',
    toolTipGetter: true,
    width: 250,
  },
  {
    headerName: 'Subject',
    field: 'subject_name',
    width: 230,
  },
  {
    headerName: 'Session Date',
    field: 'attendanceDate',
    width: 160,
  },
  {
    headerName: 'Time',
    field: 'time',
    width: 200,
    valueGetter: ({ row }) => `${row?.fromTime?.slice(0, 5)} - ${row?.toTime?.slice(0, 5)}`,
  },
  {
    headerName: 'Attendance Type',
    field: 'attendance_type_name',
    width: 160,
  },
  {
    headerName: 'Fee per Session',
    field: 'expenseAmount',
    width: 160,
  },
  {
    headerName: 'Trainer Payment',
    field: 'ledgerTP',
    width: 160,
  },
  {
    headerName: 'Lessons',
    field: 'lessons',
    width: 200,
    toolTipGetter: true,
  },
  {
    headerName: 'Remarks',
    field: 'trainerRemarks',
    width: 250,
    toolTipGetter: true,
  },
  {
    headerName: 'Timestamp',
    field: 'attendanceTimestamp',
    width: 200,
  },
  {
    headerName: 'Tutor',
    field: 'full_name',
    toolTipGetter: true,
    width: 250,
  },
  {
    headerName: 'Attendance Verification',
    field: 'attendanceVerificationStatus',
    width: 220,
    renderCell: ({ value }) => (
      <Chip
        label={value ? (value === 1 ? 'Approved' : 'Rejected') : 'Pending'}
        color={value ? (value === 1 ? 'success' : 'error') : 'warning'}
        variant="outlined"
      />
    ),
  },
  {
    field: 'Invoice',
    headerName: 'Action',
    type: 'action',
    actionType: '',
    icon: 'bitcoin-icons:verify-filled',
    actionKey: 'Attendance Details',
    width: 140,
    buttonName: 'Verify',
    isDisabled: ({ row }) => Boolean(row?.attendanceVerificationStatus),
  },
];
